<template>
  <div>
    <el-table
      :data="eventsSliced"
      style="width: 100%"
      row-key="id"
      size="small"
      empty-text="Aucun événement trouvé"
    >
      <el-table-column label="Créé le" width="90" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>

      <el-table-column label="Nom" width="300" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.dynamicContent?.name }}
            <el-popover
              v-if="scope.row.dynamicContent?.content"
              placement="top"
              trigger="hover"
            >
              <div v-html="scope.row.dynamicContent.content"></div>
              <template #reference>
                <i class="fa fa-info-circle ml-05"></i>
              </template>
            </el-popover>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Publié" :width="publishedWidth" align="center">
        <template slot-scope="scope">
          <DatePeriodStatusBadge
            v-if="
              scope.row.dynamicContent?.publishedPeriod &&
              (scope.row.dynamicContent?.publishedPeriod?.start ||
                scope.row.dynamicContent?.publishedPeriod?.end)
            "
            :start="scope.row.dynamicContent?.publishedPeriod?.start"
            :end="scope.row.dynamicContent?.publishedPeriod?.end"
          />

          <span v-else>
            {{ scope.row.dynamicContent?.published ? "Oui" : "Non" }}
          </span></template
        ></el-table-column
      >

      <el-table-column
        prop="viewedAt"
        label="Vu le"
        min-width="150"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.viewedAt">
            {{ formatDateTime(scope.row.viewedAt) }}
          </span>

          <button
            v-else-if="
              !scope.row.viewedAt &&
              hasPermission($store.state.user, 'USERS_WRITE')
            "
            class="btn btn-primary btn-sm"
            @click="setViewedAt(scope.row)"
          >
            Marqué comme vu
          </button>
        </template>
      </el-table-column>
    </el-table>

    <paginate
      v-if="pageCount > 1"
      style="margin-top: 20px; margin-left: 20px"
      v-model="page"
      :page-count="pageCount"
      :click-handler="changePage"
      prev-text="Précédent"
      next-text="Suivant"
      container-class="pagination"
    ></paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

import DatePeriodStatusBadge from "@/components/stats/DatePeriodStatusBadge.vue";

export default {
  components: {
    Paginate,
    DatePeriodStatusBadge,
  },

  props: {
    dynamicContentData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isOpenCard: false,
      offset: 0,
      limit: 10,
      page: 1,
      dynamicContent: this.dynamicContentData,
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.dynamicContent.length / this.limit);
    },

    publishedWidth() {
      return this.dynamicContent.some(
        (item) => item.dynamicContent?.publishedPeriod,
      )
        ? 150
        : 80;
    },

    eventsSliced() {
      return this.dynamicContent.slice(this.offset, this.offset + this.limit);
    },
  },

  methods: {
    changePage(page) {
      this.page = page;
      this.offset = this.limit * page - this.limit;
    },

    async setViewedAt(dataEvent) {
      try {
        const { data } = await this.$api.patch(
          `/users/events/${dataEvent.dynamicContentId}/viewed`,
          {
            coachEmail: dataEvent.userEmail,
            eventType: "dynamicContent",
          },
        );

        this.dynamicContent = this.dynamicContent.map((event) => {
          if (event.id === dataEvent.id) {
            return { ...event, viewedAt: data.viewedAt };
          }
          return event;
        });

        this.$successToast("L'événement a été marqué comme vu.");
      } catch (_) {
        this.$errorToast(
          "Impossible de marquer l'événement comme vu, une erreur est survenue.",
        );
      }
    },
  },
};
</script>
